import { StyledTitleImg } from './style';

export default function TitleImg({ className, imgSrc, isPlusIcon = false, editorType }) {
  return (
    <StyledTitleImg isPlusIcon={isPlusIcon} editorType={editorType}>
      <img className={className} alt="" src={imgSrc} />
    </StyledTitleImg>
  );
}
